import { API_BASE_URL } from 'redux/constants';
import ApiService from './ApiService'
import axios from 'axios';

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: '/sign-in',
        method: 'post',
        data
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
}



export async function apiResetPassword (object) {
  
    const response = await fetch(API_BASE_URL + 'Account/SetNewPassword', {
      method: "POST",
      body: JSON.stringify({
        id: object.id,
        token: object.token,
        password: object.password
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      }
    });
    var data = await response.json();
    return data;
  }



export const apiForgotPassword = async (formData) => {
    const response = await fetch(`${API_BASE_URL}Account/ForgetPassword?email=${formData.email}`, {
        method: 'POST',
    });
    const data = await response.json();
    return data;
};

export const CustomerSignUpUser = async (formData) => {
    const response = await fetch(API_BASE_URL + 'Account/SignUp', {
        method: 'POST',
        body: formData,
        headers: {
            // `Content-Type` is not required when using `FormData`, as the browser sets the correct boundary.
        },
    });
    const data = await response.json();
    return data;
};


export const apiCreateCustomer = async (formData) => {
    const response = await fetch(API_BASE_URL + 'Account/CreateCustomer', {
        method: 'POST',
        body: formData,
        headers: {
            // `Content-Type` is not required when using `FormData`, as the browser sets the correct boundary.
        },
    });
    const data = await response.json();
    return data;
};

